import { apiSlice } from "../";
import { getToken } from "shared/utils/getToken";

export interface AnaliseProvaTecnicaPeriodoDTO {
  periodo: number;
  notaMedia: number;
  notaMediaAprovados: number;
  tempoMedioSegundos: number;
  tempoMedioAprovadosSegundos: number;
  tempoMedioReprovadosSegundos: number;
}

export interface AnaliseProvaTecnicaUfDTO {
  uf: string;
  quantidadeAprovados: number;
}

export interface AnaliseProvaTecnicaCidadeDTO {
  cidade: string;
  uf: string;
  quantidadeAprovados: number;
}

export interface AnaliseProvaTecnicaDashboardDTO {
  quantidadeProvasEnviadas: number;
  quantidadeProvasRealizadas: number;
  quantidadeAprovados: number;
  quantidadeReprovados: number;
  quantidadeProvasNaoRealizadas: number;
  notaMedia: number;
  notaMediaAprovados: number;
  tempoMedioSegundos: number;
  periodos: AnaliseProvaTecnicaPeriodoDTO[];
  aprovadosPorUf: AnaliseProvaTecnicaUfDTO[];
  topCidadesAprovados: AnaliseProvaTecnicaCidadeDTO[];
}

const dashboardProvaTecnicaSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAnaliseProvaTecnicaDashboard: builder.query<
      AnaliseProvaTecnicaDashboardDTO,
      number | void
    >({
      query: (totalProvasEnviadas) => ({
        url: "analise-prova-tecnica/dashboard",
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
        ...(totalProvasEnviadas ? { params: { totalProvasEnviadas } } : {}),
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAnaliseProvaTecnicaDashboardQuery } =
  dashboardProvaTecnicaSlice;
